import store from "@/store";
import { localStorageKeys, onboardingPages } from "@/enums/common";

export function isOnboardingPage(routeName) {
  return onboardingPages.includes(routeName) ? true : false;
}

function lastVisitedPage() {
  return store.getters['common/getLocalStorageValueByKey'](localStorageKeys.lastVisitedPage);
}

function changeFirstTransitionStatus(status){
  store.commit('onboarding/setFirstTransitionStatus', status);
}

function executableLastVisitedPageRedirect() {

  const isFirstRedirect = store.getters['onboarding/getFirstTransitionStatus'];

  return (lastVisitedPage() && isFirstRedirect);
}

export {
  executableLastVisitedPageRedirect,
  changeFirstTransitionStatus,
  lastVisitedPage,
}



// WEBPACK FOOTER //
// ./src/helpers/onboarding/index.js